export const dropzoneConf = {
    "f24-extraction": {
        "mimeType": "application/pdf",
        "fileExtension": ".pdf",
        "fileColor": "#d9564b",
        "allowMultipleFiles": true,
        "dropzoneHint": "Trascina qui un file PDF<br/>o clicca per caricare"
    },
    "marelli-registri-iva": {
        "mimeType": "text/csv",
        "fileExtension": ".csv",
        "fileColor": "#58b055",
        "allowMultipleFiles": true,
        "dropzoneHint": "Trascina qui un file CSV<br/>o clicca per caricare"
    },
    "dm10-reading": {
        "mimeType": "application/pdf",
        "fileExtension": ".pdf",
        "fileColor": "#d9564b",
        "allowMultipleFiles": false,
        "dropzoneHint": "Trascina qui un file PDF<br/>o clicca per caricare"
    },
    "f24-summarize": {
        "mimeType": "application/pdf",
        "fileExtension": ".pdf",
        "fileColor": "#d9564b",
        "allowMultipleFiles": false,
        "dropzoneHint": "Trascina qui un file PDF<br/>o clicca per caricare"
    },
}